module.exports = __webpack_public_path__ + "assets/img/icon4.09fbc09b.png";